import React from 'react'
import { Button } from 'antd'
import useDownloadGuard from 'hooks/useDownloadGuard'

/**
 * Ant Design Button that self-guards against download/export rage-clicks.
 *
 * Drop-in replacement for a plain `<Button>` whose onClick triggers a
 * download: while the click's async handler is in flight the button shows a
 * spinner and ignores further clicks, so the request fires only once.
 *
 * An external `loading`/`disabled` (e.g. an availability flag or a parent-owned
 * async job) is merged with the internal in-flight state.
 *
 * The onClick handler MUST return its promise for the guard to work — see
 * useDownloadGuard.
 */
const DownloadButton = ({ onClick, loading, disabled, ...rest }) => {
  const guard = useDownloadGuard(onClick, { disabled })
  return (
    <Button
      {...rest}
      loading={loading || guard.loading}
      disabled={guard.disabled}
      onClick={guard.onClick}
    />
  )
}

export default DownloadButton
